import "../Styles/Process.css";
import { useLang } from "../i18n/useLang";
import { FaSearch, FaPencilAlt, FaCogs, FaRocket, FaChartLine } from "react-icons/fa";

function ProcessSection() {
  const { t } = useLang();
  const cards = t.home.process.cards;

  return (
    <div className="pr" aria-label="Process section">
      <h2 className="pr-title">
        {t.home.process.titleLine1} <br /> {t.home.process.titleLine2}
      </h2>

      <p className="pr-subtitle">
        {t.home.process.subtitleLine1} <br /> {t.home.process.subtitleLine2}
      </p>

      <div className="cards-row" role="list">
        {cards.map((card) => {
          const Icon = { discover: FaSearch, design: FaPencilAlt, build: FaCogs, launch: FaRocket, grow: FaChartLine }[card.variant];
          return (
            <div className="card" key={card.number} data-variant={card.variant} role="listitem">
              <div className="card-badge" aria-hidden>
                <span className="badge-number">{card.number}</span>
              </div>

              <div className="card-inner">
                <div className="card-top">
                  <div className="card-icon" aria-hidden>
                    {Icon ? <Icon aria-hidden="true" /> : null}
                  </div>

                  <h3 className="card-title">{card.title}</h3>
                </div>

                <p className="card-text">{card.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ProcessSection;
